// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/styles/" + chunkId + "." + {"51":"a8c3e979cd5afd65c37c","741":"e139609f1540303d471f"}[chunkId] + ".bundle.css";
};